import { ActionStatusTypes } from "../../types/interfaces";
import {
  IScafoldingState,
  PublicBadgeActions,
  PublicBadgeActionsTypes,
} from "./publicBadgeTypes";

// NAVIGATION
const initialPublicBadgesState: IScafoldingState = {
  badgeData: undefined,
  loadBadgeDataStatus: ActionStatusTypes?.neutral,
};

export function publicBadgeReducer(
  state = initialPublicBadgesState,
  action: PublicBadgeActions
): IScafoldingState {
  switch (action.type) {
    case PublicBadgeActionsTypes.GET_BADGE_DATA:
      return {
        ...state,
        badgeData: undefined,
        loadBadgeDataStatus: ActionStatusTypes?.loading,
      };
    case PublicBadgeActionsTypes.GET_BADGE_DATA_SUCCESS:
      return {
        ...state,
        badgeData: action.payload.badgeData,
        loadBadgeDataStatus: ActionStatusTypes?.success,
      };
    case PublicBadgeActionsTypes.GET_BADGE_DATA_FAILED:
      return {
        ...state,
        badgeData: undefined,
        loadBadgeDataStatus: ActionStatusTypes?.failed,
      };
    case PublicBadgeActionsTypes.CLEAN_BADGE_DATA:
      return {
        ...initialPublicBadgesState,
      };
    default:
      return state;
  }
}
